// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Sj6G","title":"Images90_title__3V4Yq","images":"Images90_images__32cWf"};